var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-view-page"},[_c('PageLoader'),_c('Header'),_c('main',{attrs:{"id":"main-content"}},[_c('div',{staticClass:"container"},[_c('router-view',{key:_vm.$route.fullPath})],1)]),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }